export default __webpack_public_path__ + "static/assets/med_gel_solid_02_b_mask.37c52238.png";